module.exports = __webpack_public_path__ + "img/symbol_arrow1black.8a67677e.png";